import { useTheme } from '@mui/material';

interface IProps {
  className?: string;
  height?: string;
  width?: string;
}

const TrackgoodIconSmall = ({ className, height, width }: IProps) => {
  const theme = useTheme();

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 359.9 360"
      width={width ? width : '65px'}
      height={height ? height : '65px'}
      className={className}
      enableBackground="new 0 0 359.9 360">
      
      <g id="trackgoodsmallicon__assets-icons-v2__g__l25">
        <path id="trackgoodsmallicon__assets-icons-v2__path__l26"
        fill={theme.palette.primary.main}
        d="M151.1,231.2c-1.2-5.9,0.2-12,4.5-16.2l2.8-2.8c4.2-4.2,10.3-5.6,16.2-4.5c8.9,1.7,18.5-0.8,25.4-7.7
		c6.9-6.9,9.4-16.5,7.7-25.4c-1.2-5.9,0.2-12,4.5-16.2l2.8-2.8c4.2-4.2,10.3-5.6,16.2-4.5c8.9,1.7,18.5-0.8,25.4-7.7
		c12.5-12.5,10.9-33.7-4.8-44c-9.4-6.1-21.9-5.9-31.1,0.5c-10,6.9-13.9,18.3-11.8,28.8c1.2,5.9-0.2,12-4.5,16.2l-2.8,2.8
		c-4.2,4.2-10.3,5.6-16.2,4.5c-8.9-1.7-18.5,0.8-25.4,7.7c-6.9,6.9-9.4,16.5-7.7,25.4c1.2,5.9-0.2,12-4.5,16.2l-2.8,2.8
		c-4.2,4.2-10.1,5.7-15.9,4.5c-3.7-0.8-7.6-0.8-11.3,0c-5.8,1.2-11.7-0.4-15.9-4.5l-2.8-2.8c-4.2-4.2-5.6-10.3-4.5-16.2
		c2.1-10.5-1.8-21.9-11.8-28.8c-9.2-6.4-21.8-6.6-31.1-0.5c-15.7,10.2-17.3,31.5-4.8,44c6.9,6.9,16.5,9.4,25.4,7.7
		c5.9-1.2,12,0.2,16.2,4.5l2.8,2.8c4.2,4.2,5.6,10.3,4.5,16.2c-2.1,10.5,1.8,21.8,11.7,28.7c9.5,6.6,22.6,6.6,32.1,0
		C149.3,253,153.2,241.6,151.1,231.2z" />







        
        <path id="trackgoodsmallicon__assets-icons-v2__path__l37"
        fill={theme.palette.common.black}
        d="M180,80.2c3.5,0,6.9-1.4,9.4-3.9c5.2-5.2,5.2-13.6,0-18.8c-2.5-2.5-5.8-3.9-9.4-3.9c-3.5,0-6.9,1.4-9.4,3.9
		c-5.2,5.2-5.2,13.6,0,18.8C173.1,78.8,176.4,80.2,180,80.2z" />

        
        <path id="trackgoodsmallicon__assets-icons-v2__path__l42"
        fill={theme.palette.common.black}
        d="M313.1,159.9c-11.1-11.1-29-11.1-40.1,0C262,171,262,189,273,200c11.1,11.1,29,11.1,40.1,0
		S324.2,171,313.1,159.9z" />

        
        <path id="trackgoodsmallicon__assets-icons-v2__path__l47"
        fill={theme.palette.common.black}
        d="M106.9,139.9c4.4,4.4,10.3,6.8,16.5,6.8c6.2,0,12.1-2.4,16.5-6.8c4.4-4.4,6.8-10.3,6.8-16.5
		c0-6.2-2.4-12.1-6.8-16.5c-4.4-4.4-10.3-6.8-16.5-6.8c-6.2,0-12.1,2.4-16.5,6.8c-4.4,4.4-6.8,10.3-6.8,16.5
		C100.1,129.7,102.5,135.5,106.9,139.9z" />


        
        <path id="trackgoodsmallicon__assets-icons-v2__path__l53"
        fill={theme.palette.common.black}
        d="M253,220c-4.4-4.4-10.3-6.8-16.5-6.8c-6.2,0-12.1,2.4-16.5,6.8c-9.1,9.1-9.1,23.9,0,33
		c4.4,4.4,10.3,6.8,16.5,6.8c6.2,0,12.1-2.4,16.5-6.8c4.4-4.4,6.8-10.3,6.8-16.5C259.8,230.3,257.4,224.4,253,220z" />

        
        <path id="trackgoodsmallicon__assets-icons-v2__path__l58"
        fill={theme.palette.common.black}
        d="M180,279.8c-3.5,0-6.9,1.4-9.4,3.9c-5.2,5.2-5.2,13.6,0,18.8c2.5,2.5,5.8,3.9,9.4,3.9c3.5,0,6.9-1.4,9.4-3.9
		c5.2-5.2,5.2-13.6,0-18.8C186.8,281.2,183.5,279.8,180,279.8z" />

        
      </g>
    </svg>);

};

export { TrackgoodIconSmall };